var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border_tab d-flex flex-column justify-content-around i_pt_2",class:{ selected: _vm.selected },on:{"click":_vm.tabClick}},[_c('img',{attrs:{"src":_vm.productQuestion.area02_ProductList_icon}}),_c('h5',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.productQuestion.area02_ProductList_Title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }